export const ulid = () => {
  return Date.now();
};
